import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {RedirectRule} from '../../models/redirect-rule/redirect-rule';

@Injectable({
  providedIn: 'root'
})
export class RedirectRuleService extends AbstractModelService<RedirectRule> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/redirect-rule', RedirectRule);
  }
}
